<template>
  <div>
    <h3>{{ changePasswordActive ? "Change Password" : "Password" }}</h3>

    <VButton
      v-if="!changePasswordActive"
      label="Change Password"
      size="regular"
      @click="changePasswordActive = true"
      inverted
    ></VButton>
    <div class="change-password-form__wrapper" v-else>
      <v-form :name="name" :fields="fields"></v-form>

      <div class="org-general-buttons-wrapper">
        <VButton
          size="regular"
          label="Reset"
          extraClass="org-settings-general-cancel"
          @click="_cancel"
          inverted
        >
        </VButton>

        <VButton
          size="regular"
          label="Save"
          extraClass="org-settings-general-save"
          :disabled="isLoading"
          @click="_saveSettings"
        >
        </VButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import VForm from "@/components/VForm";

// mixins
import withNavigate from "@/mixins/withNavigate";
import withToasted from "@/mixins/withToasted";
import withForm from "@/mixins/withForm";
import withValidation from "@/mixins/withValidation";

import { required, samePasswords, minLength } from "@/utils/validations";

export default Vue.component("AccountChangePasswordForm", {
  components: {
    VForm
  },

  data() {
    return {
      changePasswordActive: false,
      name: "changePassword",
      fields: [
        {
          name: "old_password",
          placeholder: "********",
          label: "Current Password",
          type: "password",
          validate: [required, minLength(8)]
        },
        {
          name: "password",
          placeholder: "********",
          label: "New Password",
          type: "password",
          validate: [required, minLength(8), this.checkPasswords]
        },
        {
          name: "password_repeat",
          placeholder: "********",
          label: "Confirm New Password",
          type: "password",
          validate: [required, minLength(8), this.checkPasswords]
        }
      ],
      submitButton: {
        label: "Change",
        position: "left"
      }
    };
  },

  mixins: [withNavigate, withToasted, withForm, withValidation],

  methods: {

    _cancel() {
      this.changePasswordActive = false;
      this.clearForm();
    },

    _saveSettings() {
      this.validateForm();

      if (this.isValid) {
        const { password, password_repeat, old_password } = this.formValues;
        this.changePassword({
          values: { password, password_repeat, old_password },
          cb: () => {
            this.successToast("Password has been changed successfully");
            this._cancel();
          },
          onError: message => {
            const m = message.description
              ? message.description
              : "Something went wrong.";
            this.errorToast(m);
          }
        });
      }
    },

    ...mapActions("auth", ["changePassword"])
  },

  computed: {
    ...mapGetters("auth", ["isLoading"])
  }
});
</script>

<style lang="scss" scoped>
$max-width: 560px;

.org-general-buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
  max-width: $max-width;
}

/deep/ form {
  flex-direction: column;
}

/deep/ .input-container,
/deep/ .v-select {
  max-width: $max-width;
  margin-bottom: 42px;

  &:last-child {
    margin-bottom: 0;
  }
}

/deep/ button.inverted.org-settings-general-cancel {
  width: 70px;
  max-width: 70px;
  min-width: auto;
  border: none;
  margin-right: 30px;
}

h3 {
  margin: 30px 0;
  font-size: 16px;
  font-family: Lato-Regular, sans-serif;
  color: $secondary-text-color;
}
</style>
